import { DefaultEffects, FontIcon, Label, mergeStyles } from "@fluentui/react";
import React, { useState } from "react";

interface INavProcesos {
  onClick: () => void;
  data: any[];
}

export const NavProcesos = (props: INavProcesos) => {
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };
  return (
    <>
      {props.data.map((value) => (
        <div
          className="ms-Grid"
          dir="ltr"
          style={{
            marginTop: "15px",
            boxShadow: DefaultEffects.elevation8,
            cursor: "pointer",
            backgroundColor: hovered ? "#e0e0e0" : "transparent", // Color de fondo diferente en hover
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div
            className="ms-Grid-row"
            onClick={props.onClick}
            style={{ cursor: "pointer" }}
          >
            <div className="ms-Grid-col ms-md6 ms-lg12">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  alignSelf: "stretch",
                }}
              >
                <FontIcon
                  aria-label="Compass"
                  iconName="ThumbnailView"
                  style={{
                    fontSize: "40px",
                    height: "100%",
                    marginLeft:'10px',
                    fontWeight: "normal",
                    color: "#0078d4",
                    width: "55px",
                  }}
                />
                <div style={{ margin: "5px 5px 5px 15px" }}>
                  <Label
                    style={{
                      padding: "0px",
                      fontSize: "12px",
                      color: "#616161",
                      fontFamily: "SF Pro Text",
                      fontWeight: 400,
                      letterSpacing: "-0.23px",
                      lineHeight: "20px",
                      width: "100%",
                      cursor: "pointer",
                    }}
                  >
                    {value.nombre}
                  </Label>
                  <Label
                    style={{
                      padding: "0px",
                      fontSize: "15px",
                      color: "#616161",
                      fontFamily: "SF Pro Text",
                      fontWeight: 400,
                      letterSpacing: "-0.23px",
                      lineHeight: "20px",
                      cursor: "pointer",
                    }}
                  >
                    {value.fechaCreada}
                  </Label>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
